import { ViewModel,View, ObservableArray } from "binder"
import  { LogisticCostInvoiceDetailView } from "./logisticCostInvoiceDetail-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";

export class LogisticCostInvoiceDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.lineItems = ObservableArray.create<InvoiceLineItem>();
    }
    closePopup(result: boolean = false) {
       
    }
    GetDefaultView(): View <ViewModel> {
        return new LogisticCostInvoiceDetailView();
    }
    public getTypeId(): string {
        return "VM-20CEA3A1-3F65-4562-A36C-84F1B89096F8"
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber; } private _parentInvoiceNumber: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set accountBalanceLabel(v: string) { this._accountBalanceLabel = v; } public get accountBalanceLabel(): string { return this._accountBalanceLabel;} private _accountBalanceLabel: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set invoiceType(v: number) { this._invoiceType = v; } public get invoiceType(): number { return this._invoiceType; } private _invoiceType: number;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state; } private _state: number;
    public set lineItems(v: ObservableArray<InvoiceLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<InvoiceLineItem> { return this._lineItems; } private _lineItems: ObservableArray<InvoiceLineItem>;
    public set confirmationTime(v: moment.Moment) { this._confirmationTime = v; } public get confirmationTime(): moment.Moment { return this._confirmationTime;} private _confirmationTime: moment.Moment;
    public set canConfirm(v: boolean) { this._canConfirm = v; } public get canConfirm(): boolean { return this._canConfirm;} private _canConfirm: boolean;
    public set deliveryCost(v: number) { this._deliveryCost = v; } public get deliveryCost(): number { return this._deliveryCost;} private _deliveryCost: number;
    public set warehouseKeepingCost(v: number) { this._warehouseKeepingCost = v; } public get warehouseKeepingCost(): number { return this._warehouseKeepingCost;} private _warehouseKeepingCost: number;
    
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadById(invoiceId: string) {
        let result = await ServerConnection.callServer('Complex/SellServices/GetInvoiceDetail', {
            InvoiceId: invoiceId,
        });
        this.id = result.Id;
        this.customerName = result.CustomerName;
        this.customerId = result.CustomerId;
        this.sellerName = result.SellerName;
        this.creationTime = moment.utc(result.CreationTime);
        this.invoiceNumber = result.InvoiceNumber;
        this.parentInvoiceNumber = result.ParentInvoiceNumber;
        this.districtName = result.DistrictName;
        this.districtId = result.DistrictId;
        this.totalPrice = result.TotalPrice;
        this.finalPrice = result.FinalPrice;
        this.invoiceType = result.InvoiceType;
        this.state = result.State;
        this.confirmationTime = result.ConfirmationTime ==null ? null : moment.utc(result.ConfirmationTime); 
        
        let warehouseNameMap : Map<string,string> = new Map<string,string>();
        if((result.IsFromRootDistrict || result.PaymentState==3 || result.PaymentState==4) || result.CanSeeWarehouseName){
            (<any[]>result.LineItems).forEach(x=>{
                if(warehouseNameMap.has(x.DeliveryWarehouseId)==false){
                    warehouseNameMap.set(x.DeliveryWarehouseId,x.DeliveryWarehouseName)
                }
            })
        }else{
            let ind=1;
            (<any[]>result.LineItems).forEach(x=>{
                if(warehouseNameMap.has(x.DeliveryWarehouseId)==false){
                    warehouseNameMap.set(x.DeliveryWarehouseId,`انبار شعب ${ind}`);
                    ind++;
                }
            })
        }

        let saleWarehouseNameMap : Map<string,string> = new Map<string,string>();
        if((result.IsFromRootDistrict || result.PaymentState==3 || result.PaymentState==4) || result.CanSeeWarehouseName){
            (<any[]>result.LineItems).forEach(x=>{
                if(saleWarehouseNameMap.has(x.SaleFromWarehouseId)==false){
                    saleWarehouseNameMap.set(x.SaleFromWarehouseId,x.SaleFromWarehouseName)
                }
            })
        }else{
            let ind=1;
            (<any[]>result.LineItems).forEach(x=>{
                if(saleWarehouseNameMap.has(x.SaleFromWarehouseId)==false){
                    saleWarehouseNameMap.set(x.SaleFromWarehouseId,`انبار شعب ${ind}`);
                    ind++;
                }
            })
        }
        this.lineItems.update(...result.LineItems.map((q, i) => {
            let r = new InvoiceLineItem(this);
            r.rowNumber = i + 1;
            r.saleFromWarehouseId = q.SaleFromWarehouseId;
            r.saleFromWarehouseName =saleWarehouseNameMap.get(q.SaleFromWarehouseId);
            r.deliveryWarehouseId = q.DeliveryWarehouseId;
            r.deliveryWarehouseName = warehouseNameMap.get(q.DeliveryWarehouseId);
            r.receiverId = q.ReceiverId;
            r.receiverName = q.ReceiverName;
            r.isDeliveryFormPrinted = q.IsDeliveryFormPrinted;
            r.deliveryFormPrintApplierName = q.DeliveryFormPrintApplierName;
            r.id = q.MeasuredProductId;
            r.deliveryTime = q.DeliveryTime ==null ? null : moment.utc(q.DeliveryTime); 
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productCarModel = q.ProductCarModel;
            r.feePrice = q.FeePrice;
            r.amount = q.Amount;
            r.deficit = q.DeficitPrice;
            r.finalPrice = q.FinalPrice;
            r.totalPrice = q.TotalPrice;
            r.additionalPrice = q.AdditionalPrice;
            r.returnReason = q.Reason;
            return r;
        }));
        this.deliveryCost = result.LogisticCost;
        this.warehouseKeepingCost = result.WarehouseKeepingCost;
        
    }
    
    back() {
        this.closePopup();
    }

    async confirm() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SellServices/AddOperationCost', {
                InvoiceId: this.id,
                LogisticCost : this.deliveryCost,
                WarehouseKeepingCost : this.warehouseKeepingCost
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess("اطلاعات با موفقیت ذخیر شد.", "ثبت هزینه حمل و نقل و انبارداری");
                this.closePopup(true);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class InvoiceLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set saleFromWarehouseId(v: string) { this._saleFromWarehouseId = v; } public get saleFromWarehouseId(): string { return this._saleFromWarehouseId; } private _saleFromWarehouseId: string;
    public set saleFromWarehouseName(v: string) { this._saleFromWarehouseName = v; } public get saleFromWarehouseName(): string { return this._saleFromWarehouseName; } private _saleFromWarehouseName: string;
    public set deliveryWarehouseId(v: string) { this._deliveryWarehouseId = v; } public get deliveryWarehouseId(): string { return this._deliveryWarehouseId; } private _deliveryWarehouseId: string;
    public set deliveryWarehouseName(v: string) { this._deliveryWarehouseName = v; } public get deliveryWarehouseName(): string { return this._deliveryWarehouseName; } private _deliveryWarehouseName: string;
    public set receiverId(v: string) { this._receiverId = v; } public get receiverId(): string { return this._receiverId;} private _receiverId: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName;} private _receiverName: string;
    public set isDeliveryFormPrinted(v: boolean) { this._isDeliveryFormPrinted = v; } public get isDeliveryFormPrinted(): boolean { return this._isDeliveryFormPrinted; } private _isDeliveryFormPrinted: boolean;
    public set deliveryFormPrintApplierName(v: string) { this._deliveryFormPrintApplierName = v; } public get deliveryFormPrintApplierName(): string { return this._deliveryFormPrintApplierName; } private _deliveryFormPrintApplierName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set deficit(v: number) { this._deficit = v; } public get deficit(): number { return this._deficit; } private _deficit: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set additionalPrice(v: number) { this._additionalPrice = v; } public get additionalPrice(): number { return this._additionalPrice; } private _additionalPrice: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set deliveryTime(v: moment.Moment) { this._deliveryTime = v; } public get deliveryTime(): moment.Moment { return this._deliveryTime;} private _deliveryTime: moment.Moment;
    public set returnReason(v: string) { this._returnReason = v; } public get returnReason(): string { return this._returnReason;} private _returnReason: string;
    
}

